import {
    Calendar,
    Clock,
    MapPin,
} from "lucide-react";

import {
    formatDisplayDate,
} from "../../utils/timeUtils";

function NextBookingCard({
    booking,
}) {

    if (!booking) {

        return (

            <div style={styles.card}>

                <h3 style={styles.title}>
                    Next Booking
                </h3>

                <div style={styles.emptyState}>

                    <div style={styles.emptyText}>
                        No upcoming bookings
                    </div>

                </div>

            </div>
        );
    }

    return (

        <div style={styles.card}>

            <h3 style={styles.title}>
                Next Booking
            </h3>

            <div style={styles.bookingCard}>

                <h2 style={styles.courtName}>
                    {booking.courtName}
                </h2>

                <div style={styles.metaList}>

                    <div style={styles.metaItem}>

                        <Calendar
                            size={16}
                        />

                        <span>

                            {formatDisplayDate(
                                booking.date
                            )}

                        </span>

                    </div>

                    <div style={styles.metaItem}>

                        <Clock
                            size={16}
                        />

                        <span>

                            {booking.timeSlot}

                            {" "}

                            (
                            {booking.duration}h
                            )

                        </span>

                    </div>

                    <div style={styles.metaItem}>

                        <MapPin
                            size={16}
                        />

                        <span>
                            {booking.location}
                        </span>

                    </div>

                </div>

            </div>

        </div>
    );
}

const styles = {

    card: {

        background:
            "rgba(0,40,70,0.72)",

        border:
            "1px solid rgba(0,255,136,0.15)",

        borderRadius:
            "24px",

        padding:
            "24px",

        backdropFilter:
            "blur(10px)",
    },

    title: {

        margin: 0,

        marginBottom:
            "20px",

        color:
            "#fff",

        fontSize:
            "24px",

        fontWeight:
            "800",
    },

    bookingCard: {

        background:
            "rgba(255,255,255,0.04)",

        border:
            "1px solid rgba(255,255,255,0.08)",

        borderRadius:
            "18px",

        padding:
            "20px",
    },

    courtName: {

        margin: 0,

        marginBottom:
            "18px",

        color:
            "#00ff88",

        fontSize:
            "24px",

        fontWeight:
            "800",
    },

    metaList: {

        display:
            "flex",

        flexDirection:
            "column",

        gap:
            "14px",
    },

    metaItem: {

        display:
            "flex",

        alignItems:
            "center",

        gap:
            "10px",

        color:
            "#d1d5db",

        fontSize:
            "15px",
    },

    emptyState: {

        height:
            "220px",

        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",
    },

    emptyText: {

        color:
            "#94a3b8",

        fontSize:
            "16px",
    },
};

export default NextBookingCard;